module.exports = __webpack_public_path__ + "img/new-user-icon.6d295289.svg";